import constant from "lib/constant/constant";

const {
  CITY,
  COUNTRY,
  EMAIL,
  FIRST_NAME,
  LAST_NAME,
  PHONE_NUMBER,
  POSTAL_CODE,
  PROVINCE_CODE,
  STREET_ADDRESS,
} = constant;

const textFields = [
  {
    label: "First Name",
    placeholder: "First Name",
    key: FIRST_NAME,
    type: "text",
  },
  {
    label: "Last Name",
    placeholder: "Last Name",
    key: LAST_NAME,
    type: "text",
  },
  {
    label: "Email",
    placeholder: "Email",
    key: EMAIL,
    type: "text",
  },
  {
    label: "Phone Number",
    placeholder: "Phone Number",
    key: PHONE_NUMBER,
    type: "text",
    min: 0,
  },
  {
    label: "Address",
    placeholder: "Address",
    key: STREET_ADDRESS,
    type: "text",
  },
  {
    label: "City",
    placeholder: "City",
    key: CITY,
    type: "text",
  },
  {
    label: "Country/Province/State(Required for 'UPS' and 'Canada post')",
    placeholder: "Country/Province/State(Required for 'UPS' and 'Canada post')",
    key: PROVINCE_CODE,
    type: "text",
  },
  {
    label: "Country",
    placeholder: "Country",
    key: COUNTRY,
    type: "text",
  },
  {
    label: "Postal code/Zip code",
    placeholder: "Postal code/Zip code",
    key: POSTAL_CODE,
    type: "text",
  },
];

export default textFields;
